import { MouseEvent, useState } from 'react';

import { IconButton, Spacer } from '@chakra-ui/react';
import { MdOutlineVisibility, MdOutlineVisibilityOff } from 'react-icons/md';

import { useDecryptSsnMutation } from '../../gql/generated/graphql';

type MaskedSsnButtonProps = {
  type: 'form' | 'payoff' | 'customerInfo';
  onClick: (value: boolean, ssn: string, ssnId: number | null) => void;
  customerId?: number | null;
  tempInfoId?: number | null;
  originalLesseeId?: number | null;
  visible?: boolean;
};

const MaskedSsnButton = ({
  type,
  onClick,
  customerId,
  tempInfoId,
  originalLesseeId,
  visible,
}: MaskedSsnButtonProps) => {
  const [isHidden, setIsHidden] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [decryptSSN] = useDecryptSsnMutation();

  const handleClick = async (event: MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    setIsLoading(true);
    if (isHidden) {
      const ssn = await decryptSSN({
        variables: {
          customerId: parseInt(customerId as unknown as string, 10) || null,
          tempInfoId: tempInfoId || null,
          originalLesseeId: originalLesseeId || null,
        },
      });
      setIsHidden(!isHidden);
      onClick(!isHidden, ssn?.data?.decryptSSN?.ssn || '', ssn?.data?.decryptSSN?.ssnId || null);
    } else {
      setIsHidden(!isHidden);
      onClick(!isHidden, '', null);
    }
    setIsLoading(false);
  };

  return (
    <>
      {type === 'form' && <Spacer />}
      <IconButton
        variant="iconHover"
        size="xs"
        height="100%"
        isLoading={isLoading}
        icon={isHidden ? <MdOutlineVisibility size={15} /> : <MdOutlineVisibilityOff size={15} />}
        visibility={type === 'payoff' && !visible ? 'hidden' : 'visible'}
        onClick={handleClick}
        aria-label="Show/Hide SSN"
      />
      {type !== 'form' && <Spacer />}
    </>
  );
};

export default MaskedSsnButton;
